(function ($) {
  "use strict";

  function resolveBlockEl(blockEl) {
    if (!blockEl || !blockEl.length) {
      return $();
    }
    if (blockEl.hasClass("deac-block-image-slider")) {
      return blockEl;
    }
    return blockEl.find(".deac-block-image-slider").first();
  }

  function initializeBlock(blockEl) {
    blockEl = resolveBlockEl(blockEl);
    if (!blockEl.length || blockEl.data("swiper-initialized")) {
      return;
    }

    var $container = blockEl.find(".swiper-container").first();
    var containerEl = $container.get(0);
    if (!containerEl || typeof Swiper === "undefined") {
      return;
    }

    blockEl.data("swiper-initialized", true);

    var $next = blockEl.find(".swiper-button-next");
    var $prev = blockEl.find(".swiper-button-prev");

    new Swiper(containerEl, {
      loop: true,
      navigation: {
        nextEl: $next.get(0),
        prevEl: $prev.get(0),
      },
      speed: 500,
      on: {
        transitionStart: function () {
          blockEl.find("video").each(function () {
            this.pause();
          });
        },

        transitionEnd: function () {
          var $active = $(this.slides[this.activeIndex]);
          if (!$active.length) {
            return;
          }

          var activeSlideVideo = $active.find("video").get(0);
          var activeSlideImage = $active.find("img.image-video").get(0);

          if (activeSlideVideo) {
            setTimeout(function () {
              activeSlideVideo.play();
            }, 300);

            activeSlideVideo.addEventListener(
              "ended",
              function () {
                activeSlideVideo.style.display = "none";
                if (activeSlideImage) {
                  activeSlideImage.style.display = "block";
                }
              },
              { once: true }
            );
          }
        },
      },
    });
  }

  $(document).ready(function () {
    $(".deac-block-image-slider").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=deac-image-slider",
      function (blockEl) {
        initializeBlock(blockEl);
      }
    );
  }
})(jQuery);
